export default {
  "content": "<path d=\"M10.667 2.313H14v3.334M2.667 13.647L14 2.313\" stroke=\"#C33232\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M14 10.98v3.334h-3.333M10 10.313l4 4M2.667 2.98L6 6.314\" stroke=\"#CE6A6B\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "16",
    "height": "17",
    "viewBox": "0 0 16 17",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};